<template>
    <div v-if="show" :style="zsStyle" :class="{ [`${position}`]: true }" class="zs-tooltip">
        <slot>
            <div v-html="msg"></div>
        </slot>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    msg: {
        type: String,
        default: ''
    },
    position: {
        type: String,
        default: 'top'
    },
    bgColor: {
        type: String,
        default: '#333'
    },
    fgColor: {
        type: String,
        default: 'white'
    },
    show: {
        type: Boolean,
        default: false
    },
    border: {
        type: String,
        default: 'white'
    }
});

const zsStyle = computed(() => {
    return {
        '--bg-color': props.bgColor,
        '--fg-color': props.fgColor,
        '--border-color': props.border
    }
});
</script>

<style scoped>
.zs-tooltip {
    padding: 10px;
    white-space: nowrap;
    position: relative;
    color: var(--fg-color);
    background-color: var(--bg-color);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

    &::before {
        content: '';
        position: absolute;
        width: 20px;
        height: 20px;
        top: 75%;
        transform: rotate(45deg);
        background-color: var(--bg-color);
    }

    &::after {
        content: '';
        position: absolute;
        width: 20px;
        height: 20px;
        top: 75%;
        transform: rotate(45deg);
        background-color: var(--bg-color);
    }

    &.left {
        margin-right: 6px;

        &::after {
            content: '';
            position: absolute;
            width: 0px;
            height: 0px;
            top: calc(50% - 6px);
            right: -5px;
            transform: rotate(-45deg);
            z-index: 0;
            border: 6px solid var(--bg-color);
            /* border-top-color: transparent;
            border-left-color: transparent; */
        }

        &::before {
            content: '';
            position: absolute;
            width: 0px;
            height: 0px;
            top: calc(50% - 6px);
            right: -6px;
            transform: rotate(-45deg);
            z-index: 0;
            border: 6px solid var(--border-color);
            /* border-top-color: transparent;
            border-left-color: transparent; */
        }
    }

    &.right {

        margin-right: 6px;

        &::before {
            content: '';
            position: absolute;
            width: 0px;
            height: 0px;
            top: calc(50% - 6px);
            right: -6px;
            transform: rotate(-45deg);
            z-index: 0;
            border: 6px solid var(--border-color);
            /* border-top-color: transparent;
            border-left-color: transparent; */
        }

        &::after {
            content: '';
            position: absolute;
            width: 0px;
            height: 0px;
            top: calc(50% - 6px);
            left: -5px;
            transform: rotate(-45deg);
            z-index: 0;
            border: 6px solid var(--bg-color);
            /* border-top-color: transparent;
            border-left-color: transparent; */
        }
    }

    &.top-left,
    &.top,
    &.top-right {
        margin-bottom: 10px;

        &::before {
            content: '';
            position: absolute;
            width: 0px;
            height: 0px;
            left: calc(50% - 12px);
            /* right: -6px; */
            transform: rotate(45deg);
            z-index: 0;
            border: 6px solid var(--border-color);
            /* border-top-color: transparent;
            border-left-color: transparent; */
            top: calc(100% - 5px);
        }

        &::after {
            content: '';
            position: absolute;
            width: 0px;
            height: 0px;
            left: calc(50% - 12px);
            /* right: -6px; */
            transform: rotate(45deg);
            z-index: 0;
            border: 6px solid var(--bg-color);
            /* border-top-color: transparent;
            border-left-color: transparent; */
            top: calc(100% - 6px);
        }
    }



    &.right {
        margin-left: 6px;

        &::before {
            content: '';
            position: absolute;
            width: 0px;
            height: 0px;
            top: calc(50% - 6px);
            left: -6px;
            transform: rotate(45deg);
            z-index: 0;
            border: 6px solid var(--border-color);
            /* border-top-color: transparent;
            border-left-color: transparent; */
        }
    }


    &.bottom,
    &.bottom-right,
    &.bottom-left {
        margin-top: 10px;

        &::before {
            content: '';
            position: absolute;
            width: 0px;
            height: 0px;
            left: calc(50% - 12px);
            transform: rotate(-135deg);
            z-index: 0;
            border: 6px solid var(--fg-color);
            top: -7px;
        }

        &::after {
            content: '';
            position: absolute;
            width: 0px;
            height: 0px;
            left: calc(50% - 12px);
            transform: rotate(-135deg);
            z-index: 0;
            border: 6px solid var(--bg-color);
            top: -6px;
        }
    }
}
</style>